import { render, staticRenderFns } from "./ShopProductSeckill.vue?vue&type=template&id=cdb638d6&scoped=true&"
import script from "./ShopProductSeckill.vue?vue&type=script&lang=js&"
export * from "./ShopProductSeckill.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductSeckill.vue?vue&type=style&index=0&id=cdb638d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb638d6",
  null
  
)

export default component.exports